 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		214: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"6962ae5","1":"99cfb3c","2":"d70fcb1","3":"35fb6ae","4":"beb7ecc","5":"5382a06","6":"f2c99ca","7":"041e30e","8":"9af19d0","9":"dc28261","10":"165a62b","11":"f1a933b","12":"182e243","13":"7b49a94","14":"af3c72d","15":"51bae59","16":"b2d4966","17":"26fc4c0","18":"2f23ad5","19":"a588065","20":"50528c2","21":"d30f39b","22":"b9c0e77","23":"1001da7","24":"1398407","25":"8ec68a5","26":"2a121bd","27":"228c943","28":"d6c05db","29":"87eccb4","30":"d1a48f0","31":"d33116e","32":"9181175","33":"9b23423","34":"e506aeb","35":"d9eb947","36":"7e9e6fd","37":"887ee1c","38":"8801a29","39":"66b2740","40":"8d0b686","41":"00e52e3","42":"de4547f","43":"225e1ba","44":"2f8522a","45":"bca40e8","46":"216b46c","47":"0ed3911","48":"24cc10e","49":"de0cc53","50":"83e5207","51":"62a39e8","52":"4bdd514","53":"588d909","54":"eec18dd","55":"5ec347d","56":"0b13427","57":"f943d5c","58":"6ee39c4","59":"ac72d0c","60":"1456ae7","61":"ae341f5","62":"90b51a3","63":"80be409","64":"43adcf8","65":"0c1f389","66":"75a63ba","67":"da04ea9","68":"fbf95db","69":"bfd49f0","70":"2f955bf","71":"8f5ddeb","72":"eb6fb93","73":"8733444","74":"42620d9","75":"4437251","76":"6ef958c","77":"74dea8e","78":"23cb79b","79":"fa3f902","80":"55d00b9","81":"63d029e","82":"f2542eb","83":"69041fd","84":"085af6a","85":"dd7b45e","86":"2556948","87":"fe073b6","88":"7367aec","89":"49f4ebe","90":"6e0295c","91":"fc75659","92":"4b234de","93":"49bb08c","94":"21d8453","95":"66219a9","96":"f321dff","97":"c4234f4","98":"aee4e78","99":"27c323e","100":"b5ffadb","101":"3426434","102":"ae2d140","103":"bc0036e","104":"e8e1dc2","105":"de8e517","106":"af7d3db","107":"b87a9a6","110":"67b1a6d","111":"68b1efa","112":"aba0b1f","113":"9ad487d","114":"663dddf","115":"c34b00b","116":"b489027","117":"3bb84cd","118":"75cba41","119":"56eb4cf","120":"4b62c64","121":"80e01ee","122":"ef1fe8d","123":"1c72edc","124":"5eb8822","125":"5c9dedd","126":"9ff4536","127":"0af7700","128":"afd5c48","129":"e3bee9b","130":"fe34aed","131":"9552bc0","132":"52c86c1","133":"e9afdbe","134":"4e99a5c","135":"87806ae","136":"c0f7738","137":"ad9d3a7","138":"73c87dd","139":"aa8be66","140":"d7385e1","141":"76645c2","142":"4465f64","143":"0863c29","144":"4678b20","145":"45f44f4","146":"5c398e2","147":"f94b872","148":"53c7b89","149":"95e520c","150":"2abeaad","151":"bd9b11b","152":"33bdfde","153":"1085487","154":"71b452d","155":"0c68385","156":"2e2b0aa","157":"c0a64c1","158":"15ff195","159":"959d907","160":"55ae167","161":"7d77661","162":"14eb3d5","163":"a8b0b02","164":"800958a","165":"33acdbf","166":"87a2eb8","167":"3320fde","168":"8a279d7","169":"aad434b","170":"96f335d","171":"2d75a99","172":"7c0f8c7","173":"d713fc7","174":"d25c87a","175":"2205e3c","176":"de42f61","177":"0047c78","178":"7a5c287","179":"592da9a","180":"2f82dd4","181":"f97acab","182":"963d492","183":"5cfdb3c","184":"9f1a535","185":"447ccaf","186":"f9c82d4","187":"33200bb","188":"cd8c216","189":"74138eb","190":"b1cd039","191":"1e5ec4e","192":"2e25420","193":"3ac0265","194":"2ff7e82","195":"dd89fe5","196":"8ce56ff","197":"25db48f","198":"322163f","199":"b39061f","200":"b24bdc8","201":"4f13f78","202":"3183462","203":"5f4e100","204":"da9a043","205":"e8c678f","206":"7723d4f","207":"300375e","208":"f9a2b1a","209":"e30e7ff","210":"83cfee4","211":"52ba92d","212":"71c888b","213":"ea1bdba","216":"41c150c","217":"1a00809","218":"4366d30","219":"27ec24e","220":"0242139","221":"58dc384","222":"b6bab2a","223":"5d9fb55","224":"bff83c6","225":"889752a","226":"d86ce74","227":"df8d08a","228":"433bac2","229":"12eaefb","230":"b2097f3","231":"36fa0e9","232":"af51029","233":"09ce660","234":"709bd64","235":"29a4cb8","236":"e1799fc","237":"2391962","238":"07c5f18","239":"9814d07","240":"4f8a465","241":"845d411","242":"3b98db6","243":"a7766b4","244":"563d9e4","245":"ff0d853","246":"4c60542","247":"efa0bf3","248":"e2dec27","249":"3ce84ed","250":"7a2df5a","251":"eec0c02","252":"769b281","253":"473da4b","254":"d79b695","255":"2958144","256":"ccef57c","257":"4745352","258":"506709a","259":"fef33ef","260":"774fe42","261":"abc68dd","262":"6b928ab","263":"be53741","264":"cc5afec","265":"b3be3e7","266":"17a53b3","267":"5c62275","268":"e5d92e1","269":"dc61bdb","270":"852455a","271":"92d0b74","272":"5efb732","273":"9584e13","274":"2e7f089","275":"13efc48","276":"f3c6214","277":"163f94c","278":"748d637","279":"858d83e","280":"73b8b36","281":"45dccba","282":"498c31f","283":"f03b8ed","284":"49e7b01","285":"26a7ea3","286":"9febe0d","287":"83ef074","288":"2edd493","289":"9cf268d","290":"e8bb39e","291":"8ff1f03","292":"6360ef2","293":"fb519ed","294":"4cd69af","295":"c05459d","296":"a0dc15d","297":"e6e31b8","298":"b575f89","299":"2c3bdd5","300":"d023510","301":"7f55895","302":"8399860","303":"4fe0445","304":"65e90e2","305":"9724832","306":"82580d8","307":"afbdfe2","308":"44b37ef","309":"2badb9b","310":"fc0b6bf","311":"de4bb07","312":"7ff6e3a","313":"f9710b4","314":"0412907","315":"1bc9da8","316":"5c156f5","317":"831adc5","318":"f2ffeb7","319":"090ce6f","320":"74c43be","321":"1ce1465","322":"5a5c4c5","323":"3345b65","324":"6172b6b","325":"929021b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d2kaq61j235tiz.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
